module.exports = __webpack_public_path__ + "img/construction-design.c9c1eaef.jpg";